import axios, { AxiosError } from "axios";
import { SERVER_URL } from "./Process";

const apiClient = axios.create({
  baseURL: SERVER_URL,
  withCredentials: true,
});

apiClient.defaults.headers.common["Content-Type"] = "application/json";
apiClient.defaults.headers.common["Accept"] = "application/json";

apiClient.interceptors.request.use(
  async (config: any) => {
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    let errorMessage = "An unexpected error occurred.";

    if (error.response) {
      // Server responded with a status other than 2xx
      console.error("API error:", {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers,
      });

      const err = error.response.data as {
        Message?: string;
      };

      const serverErrMsg = err.Message;

      switch (error.response.status) {
        case 400:
          errorMessage =
            serverErrMsg || "Bad Request. Please check your input.";
          break;

        case 401:
          const res401 = error.response.data as {
            Message?: string;
          };
          errorMessage = `UNAUTHORIZED ACCESS ${res401?.Message ?? ""}`;
          break;

        case 403:
          errorMessage =
            serverErrMsg ||
            "Forbidden - you do not have permission to access this resource.";
          break;

        case 404:
          errorMessage = serverErrMsg || "NOT_FOUND";
          break;

        case 422:
          const data = error.response.data as {
            Message?: string;
            errors?: Record<string, string[]>;
          };

          if (data.errors) {
            errorMessage = Object.values(data.errors).flat().join(", ");
          } else {
            errorMessage = data.Message || "Validation error occurred.";
          }
          break;

        case 500:
          errorMessage =
            serverErrMsg || "Server error occurred. Please try again later.";
          if (serverErrMsg?.match("Object reference")) {
            errorMessage =
              "One or more validation error occured, kindly complete all required fields";
          }
          break;

        default:
          const res = error.response.data as {
            Message?: string;
          };

          errorMessage = res.Message || "An error occurred";
      }
    } else if (error.request) {
      // No response received
      console.error("Network error:", {
        message: error.message,
        config: error.config,
      });
      errorMessage = "Network error. Please check your connection.";
    } else {
      // Something else happened
      console.error("Unexpected error:", {
        message: error.message,
        config: error.config,
      });
      errorMessage = "Unexpected error. Please try again later.";
    }

    // Optionally, you can return a custom error object or message
    return Promise.reject(errorMessage);
  }
);

export default apiClient;
